import React, { useState } from 'react'
import { Input, Grid, Row, Panel, Table } from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { cloneDeep } from 'lodash'
import TooltipButton from '../../components/buttons/TooltipButton'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import {
  DELETE_ERR_MSG,
  DELETE_SUCCESS_MSG,
  SAVE_ERR_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import {
  deleteProgressResult,
  saveSingegleProgressResult,
} from '../../redux/actions/projectProgress'

export default function ProgessResultForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  projectId,
  progressId,
  setFormSchema,
  ...props
}) {
  const newRowPrefixKey = 'ADD_ID_'

  // const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState()
  const [deleteObj, setDeleteObj] = useState()
  const [isShowDeleteCF, setIsShowDeleteCF] = useState(false)

  const [expectedResultList, setExpectedResultList] = useState(
    cloneDeep(schema.expectedResult?.values || [])
  )
  const [extendResultList, setExtendResultList] = useState(
    cloneDeep(schema.extendResult?.values || [])
  )

  const { Column, HeaderCell, Cell } = Table

  const handleCallSaveService = async (request, projectId, progressId) => {
    startLoading()
    setIsLoading(true)
    let indicator = null
    try {
      console.log('call saveSingegleProgressResult.')
      indicator = await saveSingegleProgressResult(projectId, progressId, request)

      notification.open('success', {
        title: SAVE_SUCCESS_MSG,
        duration: 10000,
      })
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsLoading(false)
    doneLoading()

    return indicator
  }

  const handleCallDeleteService = async (type, id) => {
    startLoading()
    setIsLoading(true)
    let isSuccess = false
    try {
      console.log('call deleteProgressResult.')
      isSuccess = await deleteProgressResult(type, id)
      notification.open('success', {
        title: DELETE_SUCCESS_MSG,
        duration: 10000,
      })
    } catch (e) {
      //โชว popup
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DELETE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsLoading(false)
    doneLoading()
    setIsShowDeleteCF(false)
    setDeleteObj()
    return isSuccess
  }

  const onExpectedResultActualChange = (rowData, value) => {
    let arr = [...expectedResultList]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData.id) {
        arr[index].actualValue = value
        console.log(arr[index].actualValue)
        setExpectedResultList(arr)
        setValue(schema.expectedResult.name, arr)
        break
      }
    }
  }

  const onExtendResulActualChange = (rowData, value) => {
    let arr = [...extendResultList]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData.id) {
        arr[index].actualValue = value

        setExtendResultList(arr)
        setValue(schema.extendResult.name, arr)
        break
      }
    }
  }

  const onExpectedResultChange = (rowData, value) => {
    let arr = [...expectedResultList]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData.id) {
        arr[index].expectedValue = value

        setExpectedResultList(arr)
        setValue(schema.expectedResult.name, arr)
        break
      }
    }
  }

  const onExtendResulChange = (rowData, value) => {
    let arr = [...extendResultList]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData.id) {
        arr[index].expectedValue = value

        setExtendResultList(arr)
        setValue(schema.extendResult.name, arr)
        break
      }
    }
  }

  const isNewRow = (id) => {
    //console.log(id)
    return id.startsWith(newRowPrefixKey)
  }

  const onAddNewExpectedResultRow = (rowData) => {
    let arr = [...expectedResultList]
    console.log('expectedResultList', expectedResultList)

    let date = new Date().getTime()
    let data = {
      id: `${newRowPrefixKey}${date}`,
      actualValue: '',
      enableDelete: true,
      expectedValue: '',
      isDelete: false,
    }
    arr.push(data)

    console.log('after add ', arr)
    setExpectedResultList(arr)
    setValue(schema.expectedResult.name, arr)
  }

  const onDeleteExpectedResultRow = async (rowData, index) => {
    let arr = [...expectedResultList]
    console.log('expectedResultList', expectedResultList)

    // expectedResultList.forEach((element, index) => {
    //   if (rowData.id == element.id) {
    //     arr.splice(index, 1)
    //   }
    // })

    if (!isNewRow(rowData.id)) {
      var result = await handleCallDeleteService(1, rowData.id)

      if (result) {
        arr.splice(index, 1)
      }
    } else {
      arr.splice(index, 1)
    }

    console.log('after delete ', arr)
    setExpectedResultList(arr)
    setValue(schema.expectedResult.name, arr)

    schema.expectedResult.values = arr
    setFormSchema(schema)
  }

  const onSaveExpectedResultRow = async (rowData, index) => {
    let arr = [...expectedResultList]

    let request = {
      id: isNewRow(rowData.id) ? '' : rowData.id,
      actualValue: rowData.actualValue,
      expectedValue: rowData.expectedValue,
      type: 1,
    }

    var respData = await handleCallSaveService(request, projectId, progressId)

    if (respData) {
      arr[index].id = respData.id
      arr[index].actualValue = respData.actualValue
      arr[index].enableDelete = respData.enableDelete
      arr[index].expectedValue = respData.expectedValue
      arr[index].isDelete = respData.isDelete
    }

    setExpectedResultList(arr)
    setValue(schema.expectedResult.name, arr)

    schema.expectedResult.values = arr
    setFormSchema(schema)
  }

  const onAddNewExtendResultRow = (rowData) => {
    let arr = [...extendResultList]
    console.log('extendResultList', extendResultList)

    let date = new Date().getTime()
    let data = {
      id: `${newRowPrefixKey}${date}`,
      actualValue: '',
      enableDelete: true,
      expectedValue: '',
      isDelete: false,
    }
    arr.push(data)
    console.log('after add ', arr)
    setExtendResultList(arr)
    setValue(schema.extendResult.name, arr)
  }

  const onDeleteExtendResultRow = async (rowData, index) => {
    let arr = [...extendResultList]
    console.log('extendResultList', extendResultList)

    if (!isNewRow(rowData.id)) {
      var result = await handleCallDeleteService(2, rowData.id)

      if (result) {
        arr.splice(index, 1)
      }
    } else {
      arr.splice(index, 1)
    }

    console.log('after delete ', arr)
    setExtendResultList(arr)
    setValue(schema.extendResult.name, arr)

    schema.extendResult.values = arr
    setFormSchema(schema)
  }

  const onSaveExtendResultRow = async (rowData, index) => {
    let arr = [...extendResultList]

    let request = {
      id: isNewRow(rowData.id) ? '' : rowData.id,
      actualValue: rowData.actualValue,
      expectedValue: rowData.expectedValue,
      type: 2,
    }

    var respData = await handleCallSaveService(request, projectId, progressId)

    if (respData) {
      arr[index].id = respData.id
      arr[index].actualValue = respData.actualValue
      arr[index].enableDelete = respData.enableDelete
      arr[index].expectedValue = respData.expectedValue
      arr[index].isDelete = respData.isDelete
    }

    setExtendResultList(arr)
    setValue(schema.extendResult.name, arr)

    schema.extendResult.values = arr
    setFormSchema(schema)
  }

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Controller
              key={schema.expectedResult.name}
              name={schema.expectedResult.name}
              control={control}
              defaultValue={expectedResultList || []}
              render={(props) => {
                return (
                  <Table
                    rowKey="id"
                    cellBordered
                    // height={400}
                    // autoHeight={props.value.length <= 3}
                    autoHeight
                    wordWrap
                    data={props.value || []}
                  >
                    <Column width={500}>
                      <HeaderCell>{schema.expectedResult.columnText1}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          const inpUtName = `${schema.expectedResult.name}_${rowData.id}`
                          if (rowData.enableDelete) {
                            return (
                              <>
                                {errors[inpUtName] && (
                                  <Row style={{ marginBottom: 10 }}>
                                    <ErrorMessage error={errors[inpUtName]} />
                                  </Row>
                                )}
                                <Input
                                  key={inpUtName}
                                  name={inpUtName}
                                  placeholder={schema.expectedResult.columnText1}
                                  defaultValue={rowData.expectedValue}
                                  //inputRef={register(isValidators(schema.expectedResult.validators))}
                                  rows={6}
                                  componentClass="textarea"
                                  onChange={(val) => {
                                    onExpectedResultChange(rowData, val)
                                  }}
                                />
                              </>
                            )
                          } else {
                            return (
                              <div dangerouslySetInnerHTML={{ __html: rowData.expectedValue }} />
                            ) //(rowData.expectedValue)
                          }
                        }}
                      </Cell>
                    </Column>

                    <Column minWidth={350} flexGrow={2}>
                      <HeaderCell>{schema.expectedResult.columnText2}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          const inpUtName = `${schema.expectedResult.name}_actual_${rowData.id}`
                          return (
                            <>
                              {errors[inpUtName] && (
                                <Row style={{ marginBottom: 10 }}>
                                  <ErrorMessage error={errors[inpUtName]} />
                                </Row>
                              )}

                              <div style={{ minHeight: 240, minWidth: 250, marginTop: -10 }}>
                                <CKEditorFrom
                                  name={inpUtName}
                                  value={rowData.actualValue}
                                  schema={schema.expectedResult}
                                  register={register}
                                  Controller={Controller}
                                  control={control}
                                  errors={errors}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  onChange={(value) => {
                                    onExpectedResultActualChange(rowData, value)
                                  }}
                                  // toolbar={[['Maximize']]}
                                  toolbar={[[]]}
                                />
                              </div>

                              {/* <Input
                                key={inpUtName}
                                name={inpUtName}
                                placeholder={schema.expectedResult.columnText2}
                                defaultValue={rowData.actualValue}
                                //inputRef={register(isValidators(schema.expectedResult.validators))}
                                rows={3}
                                componentClass="textarea"
                                onChange={(val) => {
                                  onExpectedResultActualChange(rowData, val)
                                }}
                              /> */}
                            </>
                          )
                        }}
                      </Cell>
                    </Column>
                    <Column width={110} align="center" fixed="right">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return (
                            <>
                              <TooltipButton
                                style={{ width: '100%' }}
                                icon="trash"
                                tooltip={`บันทึก${schema.expectedResult.columnText1 || ''}`}
                                onClick={() => onSaveExpectedResultRow(rowData, index)}
                                disabled={isLoading}
                              >
                                บันทึก
                              </TooltipButton>
                              {rowData.enableDelete && (
                                <TooltipButton
                                  style={{ width: '100%', marginTop: 10 }}
                                  icon="trash"
                                  tooltip={`ลบ${schema.expectedResult.columnText1 || ''}`}
                                  onClick={() => {
                                    if (isNewRow(rowData.id)) {
                                      onDeleteExpectedResultRow(rowData, index)
                                    } else {
                                      setDeleteObj({
                                        title: schema.expectedResult.columnText1,
                                        type: 1,
                                        value: rowData,
                                        index: index,
                                      })
                                      setIsShowDeleteCF(true)
                                    }
                                  }}
                                  disabled={isLoading}
                                >
                                  ลบ
                                </TooltipButton>
                              )}
                            </>
                          )
                          // if (rowData.enableDelete) {
                          //   return (
                          //     <TooltipButton
                          //       icon="trash"
                          //       tooltip={`ลบ${schema.expectedResult.columnText1 || ''}`}
                          //       onClick={() => onDeleteExpectedResultRow(rowData)}
                          //     >
                          //       ลบ
                          //     </TooltipButton>
                          //   )
                          // } else {
                          //   return (
                          //     <TooltipButton
                          //       icon="plus"
                          //       tooltip={`เพิ่ม${schema.expectedResult.columnText1 || ''}`}
                          //       onClick={() => onAddNewExpectedResultRow(rowData)}
                          //     >
                          //       เพิ่ม
                          //     </TooltipButton>
                          //   )
                          // }
                        }}
                      </Cell>
                    </Column>
                  </Table>
                )
              }}
            />
            <Row style={{ textAlign: 'right', alignItems: 'end' }}>
              <TooltipButton
                style={{ width: 90, marginBottom: 10, marginRight: 15 }}
                icon="plus"
                tooltip={`เพิ่ม${schema.extendResult.columnText1 || ''}`}
                onClick={() => onAddNewExpectedResultRow()}
                disabled={isLoading}
              >
                เพิ่ม
              </TooltipButton>
            </Row>

            <Controller
              key={schema.extendResult.name}
              name={schema.extendResult.name}
              control={control}
              defaultValue={extendResultList || []}
              render={(props) => {
                return (
                  <Table
                    rowKey="id"
                    cellBordered
                    // height={400}
                    // autoHeight={props.value.length <= 3}
                    autoHeight
                    wordWrap
                    data={props.value || []}
                  >
                    <Column width={500}>
                      <HeaderCell>{schema.extendResult.columnText1}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          const inpUtName = `${schema.extendResult.name}_${rowData.id}`
                          if (rowData.enableDelete) {
                            return (
                              <>
                                {errors[inpUtName] && (
                                  <Row style={{ marginBottom: 10 }}>
                                    <ErrorMessage error={errors[inpUtName]} />
                                  </Row>
                                )}
                                <Input
                                  key={inpUtName}
                                  name={inpUtName}
                                  placeholder={schema.extendResult.columnText1}
                                  defaultValue={rowData.expectedValue}
                                  //inputRef={register(isValidators(schema.extendResult.validators))}
                                  rows={6}
                                  componentClass="textarea"
                                  onChange={(val) => {
                                    onExtendResulChange(rowData, val)
                                  }}
                                />
                              </>
                            )
                          } else {
                            return rowData.expectedValue
                          }
                        }}
                      </Cell>
                    </Column>

                    <Column minWidth={350} flexGrow={2}>
                      <HeaderCell>{schema.extendResult.columnText2}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          const inpUtName = `${schema.extendResult.name}_actual_${rowData.id}`
                          return (
                            <>
                              {errors[inpUtName] && (
                                <Row style={{ marginBottom: 10 }}>
                                  <ErrorMessage error={errors[inpUtName]} />
                                </Row>
                              )}
                              <div style={{ minHeight: 240, minWidth: 250, marginTop: -10 }}>
                                <CKEditorFrom
                                  name={inpUtName}
                                  value={rowData.actualValue}
                                  schema={schema.extendResult}
                                  register={register}
                                  Controller={Controller}
                                  control={control}
                                  errors={errors}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  onChange={(value) => {
                                    onExtendResulActualChange(rowData, value)
                                  }}
                                  // toolbar={[['Maximize']]}
                                  toolbar={[[]]}
                                />
                              </div>
                              {/* <Input
                                key={inpUtName}
                                name={inpUtName}
                                placeholder={schema.extendResult.columnText2}
                                defaultValue={rowData.actualValue}
                                //inputRef={register(isValidators(schema.extendResult.validators))}
                                rows={3}
                                componentClass="textarea"
                                onChange={(val) => {
                                  onExtendResulActualChange(rowData, val)
                                }}
                              /> */}
                            </>
                          )
                        }}
                      </Cell>
                    </Column>
                    <Column width={110} align="center" fixed="right">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return (
                            <>
                              <TooltipButton
                                style={{ width: '100%' }}
                                icon="trash"
                                tooltip={`บันทึก${schema.extendResult.columnText1 || ''}`}
                                onClick={() => onSaveExtendResultRow(rowData, index)}
                                disabled={isLoading}
                              >
                                บันทึก
                              </TooltipButton>
                              {rowData.enableDelete && (
                                <TooltipButton
                                  style={{ width: '100%', marginTop: 10 }}
                                  icon="trash"
                                  tooltip={`ลบ${schema.extendResult.columnText1 || ''}`}
                                  onClick={() => {
                                    if (isNewRow(rowData.id)) {
                                      onDeleteExtendResultRow(rowData, index)
                                    } else {
                                      console.log(rowData)
                                      setDeleteObj({
                                        title: schema.extendResult.columnText1,
                                        type: 2,
                                        value: rowData,
                                        index: index,
                                      })
                                      setIsShowDeleteCF(true)
                                    }
                                  }}
                                  disabled={isLoading}
                                >
                                  ลบ
                                </TooltipButton>
                              )}
                            </>
                          )
                        }}
                      </Cell>
                    </Column>
                  </Table>
                )
              }}
            />
            <Row style={{ textAlign: 'right', alignItems: 'end' }}>
              <TooltipButton
                style={{ width: 90, marginRight: 15 }}
                icon="plus"
                tooltip={`เพิ่ม${schema.extendResult.columnText1 || ''}`}
                onClick={() => onAddNewExtendResultRow()}
                disabled={isLoading}
              >
                เพิ่ม
              </TooltipButton>
            </Row>
          </Grid>
        </Panel>

        <ConfirmWidget
          title={`ยืนยันการลบ`}
          show={isShowDeleteCF}
          size="sm"
          detail={
            <>
              {`ยืนยันการลบ${deleteObj?.title || ''} : `}
              <b>{deleteObj?.value.expectedValue || ''}</b>
            </>
          }
          onCancle={() => {
            setIsShowDeleteCF(false)
            setDeleteObj()
          }}
          onConfirm={() => {
            if (deleteObj?.type == 1) {
              onDeleteExpectedResultRow(deleteObj.value, deleteObj.index)
            } else {
              onDeleteExtendResultRow(deleteObj.value, deleteObj.index)
            }
          }}
        />
      </Row>
    </div>
  )
}
